import { ValueLabel } from '../common';

export const properties: ValueLabel<string>[] = [
  { value: 'id', label: 'Request ID' },
  { value: 'deaNumber', label: 'DEA Number' },
  { value: 'requestType', label: 'Request Type' },
  { value: 'role', label: 'Role' },
  { value: 'updatedAt', label: 'Updated Date' },
  { value: 'status', label: 'Status' },

  { value: 'firstName', label: 'First Name' },
  { value: 'lastName', label: 'Last Name' },
  { value: 'certificateEmail', label: 'Certificate Email' },

  { value: 'srNum', label: 'Serial Number' },
];

// indivId: number;
// status: string;
// firstName: string;
// lastName: string;
// middleInitial: string;
// certificateEmail: string;
// deaNumber: string;
// regStatus: string;
// role: string;
// renewalInstNo: string;
// appStatusCd: string;
// regSrc: string;
// srNum: string;
// subscriberAddress: string;
// appStatusDt: Date;
// certExpDt: Date;
// createdAt: Date;
// updatedAt: Date;
